import { InjectionToken } from '@angular/core'
import { Observable } from 'rxjs'

export const AUCTION_FACADE = new InjectionToken<SharedAuctionFacade>('AuctionFacade')

// TODO: replace with CaptureAuctionFieldEnum later
export enum CaptureAuctionFieldEnum {
  Off = 'off',
  Optional = 'optional',
  Required = 'required',
}

export interface SharedAuctionFacade {
  urlName$: Observable<string>
  auctionCountry$: Observable<string | undefined>
  capturePhoneNumbers$: Observable<CaptureAuctionFieldEnum | '' | undefined>
  eventTicketCaptureEmail$: Observable<CaptureAuctionFieldEnum | undefined>
  eventTicketCapturePhoneNumber$: Observable<CaptureAuctionFieldEnum | undefined>
  ticketsLabel$: Observable<string | undefined>
  enablePaddleNumbers$: Observable<boolean | undefined>
  auctionCurrency$: Observable<string | undefined>
  paddleNumbersRequirePaymentMethod$: Observable<boolean | undefined>
  preAuthAtReg$: Observable<boolean>
  captureTermsAndConditions$: Observable<boolean | undefined>
  paddleStartNumber$: Observable<number | undefined>
}
